import { Component, inject, OnDestroy, signal } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from '@services/loading.service';
import { Subject, takeUntil } from 'rxjs';

/** show (infinite) loading progress on page */
@Component( {
    standalone: true,
    selector: 'riege-loading',
    imports: [ MatProgressBarModule ],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss'
} )
export class LoadingComponent implements OnDestroy {
    loading = signal( false );

    #loadingService = inject( LoadingService );

    /** lifecycle hook */
    readonly #destroyed: Subject<void> = new Subject<void>();

    /** listen on loading service to update state */
    constructor() {
        this.#loadingService.loading.pipe( takeUntil( this.#destroyed ) ).subscribe( ( state ) => {
            this.loading.set( state );
        } );
    }

    ngOnDestroy() {
        this.#destroyed.next();
        this.#destroyed.complete();
    }
}
